export const PROMOTION_TYPE_VALUE = {
  FREE: "free",
  BUNDLE: "bundle",
};

export const PROMOTION_TYPE_TEXT = {
  FREE: "สินค้าแถม",
  BUNDLE: "สินค้าราคาพิเศษ",
};

export const PROMOTION_TYPE_OPTIONS = [
  { value: PROMOTION_TYPE_VALUE.FREE, text: PROMOTION_TYPE_TEXT.FREE },
  { value: PROMOTION_TYPE_VALUE.BUNDLE, text: PROMOTION_TYPE_TEXT.BUNDLE },
];

export const PROMOTION_CONDITION_TYPE_VALUE = {
  ITEM: "item",
  AMOUNT: "amount",
  PV: "pv",
};

export const PROMOTION_CONDITION_TYPE_TEXT = {
  ITEM: "รายการสินค้า",
  AMOUNT: "ระบุยอดเงินขั้นต่ำต่อบิล",
  PV: "คะแนน",
};

export const PROMOTION_CONDITION_TYPE_OPTIONS = [
  {
    value: PROMOTION_CONDITION_TYPE_VALUE.ITEM,
    text: PROMOTION_CONDITION_TYPE_TEXT.ITEM,
  },
  {
    value: PROMOTION_CONDITION_TYPE_VALUE.AMOUNT,
    text: PROMOTION_CONDITION_TYPE_TEXT.AMOUNT,
  },
  {
    value: PROMOTION_CONDITION_TYPE_VALUE.PV,
    text: PROMOTION_CONDITION_TYPE_TEXT.PV,
  },
];
